import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const EBIDTAImpactAnalysis = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default EBIDTAImpactAnalysis